import { connect } from 'react-redux';
import HomeLoadingScreen from '../../components/Modal/HomeLoadingScreen/homeLoadingScreenView';
// States
import {
  getPercentageLoadingScreen,
  getSelectedTab,
  getLoadingStudyModes,
  getGenerateStripePaymentErrorSelector
} from '../../selectors/Course/courseSelector';
import { getLoadingHandler } from '../../selectors/loaderHandlerSelectors';
import { setNotification } from '../../actions/errorHandlerActions';

const mapStateToProps = state => ({
  loadingHandler: getLoadingHandler(state),
  loadingStudyModes: getLoadingStudyModes(state),
  valueTab: getSelectedTab(state),
  percentageLoadingScreen: getPercentageLoadingScreen(state),
  generateStripePaymentError: getGenerateStripePaymentErrorSelector(state)
});

const mapDispatchToProps = () => {
  return {
    setNotification
  };
};

const AppContainer = connect(mapStateToProps, mapDispatchToProps)(HomeLoadingScreen);

export default AppContainer;
